"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(_ref) {
  var dispatch = _ref.dispatch,
      getState = _ref.getState;
  return function (apply) {
    return function (action) {
      return typeof action === 'function' ? action(dispatch, getState) : apply(action);
    };
  };
};

exports["default"] = _default;